var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToyota(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 193.2 40.6",
    style: {
      enableBackground: "new 0 0 193.2 40.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path2821",
    className: "st0",
    d: "M24.2,34.3c-2.5-1.6-4.4-7-4.4-13.5c0-0.2,0-0.5,0-0.7l0,0c-7-1.1-12-4.1-12.2-7.7l0,0 c-1.7,2.1-2.7,4.6-2.7,7.2C5,27.4,13.4,33.7,24.2,34.3L24.2,34.3z M1.7,20.3c0-8.6,10.7-15.6,24-15.6s24,7,24,15.6 S39,35.9,25.7,35.9S1.7,28.9,1.7,20.3z M25.7,6.9c2.6,0,4.7,3.9,5.5,9.3l0,0c5-0.8,8.5-2.6,8.5-4.6c0-2.8-6.3-5-14-5s-14,2.3-14,5 c0,2.1,3.5,3.9,8.5,4.6l0,0C21,10.8,23.2,6.9,25.7,6.9z M27.3,34.3c10.7-0.6,19.2-6.9,19.2-14.6c0-2.6-1-5.1-2.7-7.2l0,0 c-0.1,3.6-5.2,6.6-12.2,7.7l0,0c0,0.2,0,0.5,0,0.7C31.6,27.3,29.7,32.7,27.3,34.3C27.2,34.3,27.3,34.3,27.3,34.3z M25.7,16.6 c1.1,0,2.3,0,3.3-0.1l0,0c-0.5-3.5-1.8-5.9-3.3-5.9s-2.8,2.4-3.3,5.9l0,0C23.5,16.6,24.6,16.6,25.7,16.6z M25.7,29.5 c1.9,0,3.5-4,3.6-9l0,0c-1.2,0.1-2.4,0.2-3.6,0.2s-2.4-0.1-3.6-0.2l0,0C22.2,25.4,23.8,29.5,25.7,29.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path2823",
    className: "st1",
    d: "M124.1,20.3c0-6.6,5.3-11.9,11.9-11.9c6.6,0,11.9,5.3,11.9,11.9c0,6.6-5.3,11.9-11.9,11.9 S124.1,26.9,124.1,20.3z M136,27.8c3.7,0,6.7-3.4,6.7-7.6c0-4.2-3-7.6-6.7-7.6s-6.7,3.4-6.7,7.6C129.4,24.5,132.4,27.8,136,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2825",
    className: "st1",
    d: "M161.5,13.3v18.4h-5V13.3l0,0h-7V9.1h19.1v4.2H161.5L161.5,13.3L161.5,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2827",
    className: "st1",
    d: "M174.6,26.6L174.6,26.6l-1.9,5.1h-5.9l9.3-22.5h3.1h3.1l9.3,22.5h-5.9l-1.9-5.1l0,0h-4.6H174.6 z M179.2,22.8h3.2l0,0l-3.1-8.2l0,0l-3.1,8.2l0,0H179.2L179.2,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2829",
    className: "st1",
    d: "M68.8,13.3v18.4h-5V13.3l0,0h-7V9.1h19.1v4.2H68.8L68.8,13.3L68.8,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2831",
    className: "st1",
    d: "M77.1,20.3c0-6.6,5.3-11.9,11.9-11.9c6.6,0,11.9,5.3,11.9,11.9c0,6.6-5.3,11.9-11.9,11.9 S77.1,26.9,77.1,20.3z M89,27.8c3.7,0,6.7-3.4,6.7-7.6c0-4.2-3-7.6-6.7-7.6s-6.7,3.4-6.7,7.6C82.4,24.5,85.4,27.8,89,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2833",
    className: "st1",
    d: "M112.5,31.7h2.6v-8.4v-0.1l8.8-14H118l-5.5,9.5L107,9.2h-5.9l8.8,14v0.1v8.4H112.5L112.5,31.7z "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyota);
export default __webpack_public_path__ + "static/media/Toyota.5f842a6893fe31c6ac68a23f98fba4d4.svg";
export { ForwardRef as ReactComponent };